// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZjMy","controls":"styles_controls__3Ttsm","charLimit":"styles_charLimit__2rs22","input":"styles_input__31kQa","send":"styles_send__julyz"};